import * as B from '@blueprintjs/core';
import classnames from 'classnames';
import React from 'react';

import TilerThumbnail from 'app/components/TilerThumbnail';
import * as mapUtils from 'app/utils/mapUtils';

import cs from './styles.module.scss';

export interface SnapshotThumbnailProps {
  url: string | null;
  /** The image is a multispectral scene's truecolor sibling standing in for it. */
  isOverride?: boolean;
  alt: string;
  className?: string;
  placeholderSize?: number;
}

/** A cart item's stored preview image, or a placeholder when it has none. */
export const SnapshotThumbnail: React.FC<SnapshotThumbnailProps> = ({
  url,
  isOverride,
  alt,
  className,
  placeholderSize,
}) => {
  if (!url) {
    return (
      <B.Icon
        icon="media"
        size={placeholderSize}
        className={classnames(cs.placeholder, className)}
      />
    );
  }
  // A stand-in truecolor thumbnail is grayscaled everywhere else it's shown, so it can't be
  // mistaken for the imagery being bought.
  const imageClassName = classnames(className, {[cs.grayscale]: isOverride}) || undefined;
  return mapUtils.isTilerUrl(url) ? (
    // Tiler thumbnails are fetched with header-based auth, so they can't go in an <img> src.
    <TilerThumbnail url={url} className={imageClassName} alt={alt} />
  ) : (
    <img className={imageClassName} src={url} alt={alt} loading="lazy" />
  );
};

export default SnapshotThumbnail;
